function present(value) {
    return value !== null && value !== undefined && String(value).trim() !== '';
}

function display(value) {
    if (!present(value)) return '';
    if (typeof value === 'boolean') return value ? 'Yes' : 'No';
    return String(value);
}

export function projectRecordArea(location = {}, legacy = {}) {
    const value = present(location.borrower_gia_m2) ? location.borrower_gia_m2
        : [legacy.gross_internal_area, legacy.proposed_gia, legacy.gia].find(present);
    return present(value) ? `${display(value)} m2 (Borrower GIA; verification separate)` : '';
}

export function projectRecordServices(surveys = {}, location = {}) {
    const keys = [['utilities_water', 'Water'], ['utilities_electric', 'Electricity'], ['utilities_gas', 'Gas'],
        ['utilities_capacity_summary', 'Capacity'], ['utility_upgrades_description', 'Upgrades']];
    const values = keys.filter(([key]) => present(surveys[key])).map(([key, label]) => `${label}: ${display(surveys[key])}`);
    return values.length ? values.join('; ') : [location.services_overview, location.existing_services,
        location.utilities_services, location.site_services].find(present) || '';
}